import { render, staticRenderFns } from "./MyFolderModal.vue?vue&type=template&id=0d48a44a&"
import script from "./MyFolderModal.vue?vue&type=script&lang=ts&"
export * from "./MyFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MyFolderPagination1: require('/home/ec2-user/environment/xsearch-app/src/components/MyFolderPagination1.vue').default,MyFolderPagination2: require('/home/ec2-user/environment/xsearch-app/src/components/MyFolderPagination2.vue').default})
